import React, { useState } from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	IconButton,
	Collapse,
	Box,
	Typography,
} from "@mui/material";
import {
	KeyboardArrowDown,
	KeyboardArrowUp,
} from "@mui/icons-material";

// Row Component
function CollapsibleRow({ paymentType, entries }) {
	const [open, setOpen] = useState(false);

	return (
		<>
			<TableRow>
				<TableCell>
					<IconButton
						aria-label="expand row"
						size="small"
						onClick={() => setOpen(!open)}
					>
						{open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
					</IconButton>
				</TableCell>
				<TableCell>{paymentType}</TableCell>
				<TableCell>{entries.length}</TableCell>
			</TableRow>
			<TableRow>
				<TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
					<Collapse in={open} timeout="auto" unmountOnExit>
						<Box margin={2}>
							<Typography variant="subtitle1" gutterBottom component="div">
								Details
							</Typography>
							<Table size="small">
								<TableHead>
									<TableRow>
										<TableCell>User ID</TableCell>
										<TableCell>Name</TableCell>
										<TableCell>Payment Date</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{entries.map((entry, idx) => (
										<TableRow key={idx}>
											<TableCell>{entry.user_id}</TableCell>
											<TableCell>{entry.name}</TableCell>
											<TableCell>
												{new Date(entry.payment_date).toLocaleString("en-GB", {
													day: "numeric",
													month: "short",
													year: "numeric",
													hour: "2-digit",
													minute: "2-digit",
												})}
											</TableCell>
										</TableRow>
									))}
								</TableBody>
							</Table>
						</Box>
					</Collapse>
				</TableCell>
			</TableRow>
		</>
	);
}

export default function ReportsTable({ data, error }) {
	if (!Array.isArray(data) || data.length === 0) {
		return (
			<TableContainer component={Paper}>
				<Table aria-label="empty table">
					<TableBody>
						<TableRow>
							<TableCell>{error || "No data available to display"}</TableCell>
						</TableRow>
					</TableBody>
				</Table>
			</TableContainer>
		);
	}

	// Group data by payment_type
	const groupedData = data.reduce((acc, curr) => {
		if (!acc[curr.payment_type]) {
			acc[curr.payment_type] = [];
		}
		acc[curr.payment_type].push(curr);
		return acc;
	}, {});

	Object.keys(groupedData).forEach((type) => {
		groupedData[type].sort((a, b) => new Date(a.payment_date) - new Date(b.payment_date));
	  });

	return (
		<TableContainer component={Paper}>
			<Table aria-label="collapsible table">
				<TableHead>
					<TableRow>
						<TableCell />
						<TableCell>Payment Type</TableCell>
						<TableCell>Count</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{Object.entries(groupedData).map(([type, entries]) => (
						<CollapsibleRow key={type} paymentType={type} entries={entries} />
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
}

